import { BlockTypes, type LayoutTypes } from './types';
import type { Breakpoint } from '@mui/material';

export const LAYOUT_CONFIG: Record<
  LayoutTypes,
  {
    blocks: string[];
    breakpoints: Record<Breakpoint, number[]>;
  }
> = {
  DI: {
    blocks: [BlockTypes.DESCRIPTION, BlockTypes.IMAGE],
    breakpoints: {
      xxl: [1, 2],
      xl: [1, 2],
      lg: [1, 2],
      sm: [1, 1],
      xs: [1, 1],
    },
  },
  DL_DI: {
    blocks: [
      BlockTypes.DOCUMENTS_LIST,
      BlockTypes.DESCRIPTION,
      BlockTypes.IMAGE,
    ],
    breakpoints: {
      xxl: [1, 2, 3],
      xl: [1, 2, 3],
      lg: [1, 2, 2],
      sm: [1, 2, 2],
      xs: [1, 1, 1],
    },
  },
  DB: {
    blocks: [BlockTypes.DESCRIPTION, BlockTypes.BIOMARKERS],
    breakpoints: {
      xxl: [1, 2],
      xl: [1, 2],
      lg: [1, 2],
      sm: [1, 1],
      xs: [1, 1],
    },
  },
  DL_DB: {
    blocks: [
      BlockTypes.DOCUMENTS_LIST,
      BlockTypes.DESCRIPTION,
      BlockTypes.BIOMARKERS,
    ],
    breakpoints: {
      xxl: [1, 2, 2],
      xl: [1, 2, 2],
      lg: [1, 2, 2],
      sm: [1, 2, 2],
      xs: [1, 1, 1],
    },
  },
  DBI: {
    blocks: [BlockTypes.DESCRIPTION, BlockTypes.BIOMARKERS, BlockTypes.IMAGE],
    breakpoints: {
      xxl: [1, 2, 3],
      xl: [1, 2, 3],
      lg: [1, 2, 2],
      sm: [1, 1, 1],
      xs: [1, 1, 1],
    },
  },
  DL_DBI: {
    blocks: [
      BlockTypes.DOCUMENTS_LIST,
      BlockTypes.DESCRIPTION,
      BlockTypes.BIOMARKERS,
      BlockTypes.IMAGE,
    ],
    breakpoints: {
      xxl: [1, 2, 2, 3],
      xl: [1, 2, 2, 3],
      lg: [1, 2, 2, 2],
      sm: [1, 2, 2, 2],
      xs: [1, 1, 1, 1],
    },
  },
};
